import React from "react";
import { DataNotFoundIcon } from "../icons";
import { dataMessage } from "../helpers/messages";

const DataNotFound = (props) => {
  const { message } = props;
  return (
    <div className="lms_datanot_found">
      {DataNotFoundIcon}
      <p>{message || dataMessage.noData}</p>
    </div>
  );
};

export default DataNotFound;
